export default {
      id: "icon-card-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-card",
      toString: function () {
        return this.url;
      }
    }